<div class="grid-viewport">
  @if (columns && idColumn) {
  <div
    class="p-table--data piensoDataGrid"
    [style.grid-template-columns]="getGridTemplate()"
    role="table"
    [attr.aria-rowcount]="page.availableRows"
    [attr.aria-colcount]="columns.length"
  >
    <div class="p-table-header-row" role="row" tabindex="-1">
      @for (column of columns; track column.prop) {
      <div class="p-table-header-cell" role="columnheader" tabindex="-1">
        <ng-container [ngTemplateOutlet]="column.headerTemplate" [ngTemplateOutletContext]="{ column }" />
      </div>
      }
    </div>
    @for (row of page.rows; track row[idColumn]; let rowIndex = $index) {
    <div class="p-table-row" role="row" tabindex="-1">
      @for (column of columns; track column.prop) {
      <div class="p-table-cell" role="cell">
        <ng-container
          [ngTemplateOutlet]="column.cellTemplate"
          [ngTemplateOutletContext]="{ row, rowIndex, value: row[column.prop], column }"
        />
      </div>
      }
    </div>
    }
  </div>
  } @if (!columns || !idColumn) {
  <div class="grid-loading-overlay p-flex p-flex-center p-flex-center-y">
    <p-progress-spinner-lg />
  </div>
  }
</div>

<div class="p-divider"></div>

<div class="p-flex p-flex-center p-p-sm paginator-footer">
  <p-paginator-md
    [length]="page.availableRows"
    [pageSize]="page.pageSize"
    [pageIndex]="page.pageNumber"
    [showPageSize]="true"
    [pageSizeOptions]="[20, 50, 100]"
    (page)="onPageChange($event)"
  />
</div>

<ng-template #rowNumHdrTpl let-col="column">
  @if (dataReloading || externalTransforming()) {
  <p-progress-spinner
    class="grid-header-spinner"
    size="medium"
    [pTooltip]="externalTransforming() ? 'Refinement in progress...' : 'Loading data...'"
    tooltipPosition="below"
  />
  } @else if (dataService().corpus; as corpus) {
  <div
    [pHeaderRenderer]="rendererProvider.getRowNumberHeaderRenderer()!"
    [column]="col"
    [corpus]="corpus"
    [editable]="editable()"
  ></div>
  }
</ng-template>

<ng-template #rowNumCellTpl let-row="row" let-i="rowIndex" let-value="value">
  {{ page.rowNumber(i) | number }}
</ng-template>

<ng-template #headerTpl let-col="column">
  @if (dataService().corpus; as corpus) {
  <div
    [pHeaderRenderer]="rendererProvider.getHeaderRenderer(col.prop)"
    [column]="col"
    [corpus]="corpus"
    [editable]="editable()"
    [page]="page"
  ></div>
  }
</ng-template>

<ng-template #cellTpl let-row="row" let-value="value" let-i="rowIndex" let-col="column">
  @if (rendererProvider.getCellRenderer(col.prop); as renderer) {
  <div
    [pCellRenderer]="renderer"
    [row]="row"
    [rowIndex]="i"
    [column]="col"
    [value]="value"
    [page]="page"
    [truncateTextLength]="1000"
  ></div>
  }
</ng-template>
